import { formatBuildLabel, readBuildInfo } from '@services/app-update/build-info';
import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-footer',
  template: `<div class="layout-footer">i11 Admin - v{{ appVersion }} ({{ appEnv }}){{ buildLabel }}</div>`
})
export class AppFooter {
  appVersion: string = environment.version;
  appEnv: string = environment.envName;
  /** Pl. „ · 364a113b · 2026-09-16 18:40”; build-azonosító nélkül üres */
  readonly buildLabel = formatBuildLabel(readBuildInfo(inject(DOCUMENT)));
}
